import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from "react";
import { DictionaryCardContent } from "./dictionary-card-content";
import { useDictionaryLexicalHints } from "./use-dictionary-lexical-hints";
const DictionaryBlockBody = memo(({ block, dictionary }) => {
    const headword = dictionary.headword?.trim() || block.title.trim() || "Dictionary";
    const definition = dictionary.definition.trim() || block.summary.trim();
    const lexical = useDictionaryLexicalHints(headword, {
        partOfSpeech: dictionary.partOfSpeech,
        phonetic: dictionary.phonetic,
    });
    return (_jsx(DictionaryCardContent, { provider: dictionary.provider, headword: headword, definition: definition, partOfSpeech: lexical.partOfSpeech, phonetic: lexical.phonetic, sourceUrl: dictionary.sourceUrl }));
});
/**
 * Render a dictionary card for a link block whose handler tagged it with
 * `subtype: "dictionary"` and populated `content.dictionary`. Renders
 * nothing for any other block so the parent dispatcher can fall through.
 */
export const DictionaryBlockView = memo(({ block }) => {
    if (block.type !== "link")
        return _jsx(_Fragment, {});
    const linkContent = block.content;
    if (linkContent.subtype !== "dictionary")
        return _jsx(_Fragment, {});
    return _jsx(DictionaryBlockBody, { block: block, dictionary: linkContent.dictionary });
});
